import { render, staticRenderFns } from "./JobCopySetting.vue?vue&type=template&id=cd20abfa&scoped=true&"
import script from "./JobCopySetting.vue?vue&type=script&lang=js&"
export * from "./JobCopySetting.vue?vue&type=script&lang=js&"
import style0 from "./JobCopySetting.vue?vue&type=style&index=0&id=cd20abfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd20abfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd20abfa')) {
      api.createRecord('cd20abfa', component.options)
    } else {
      api.reload('cd20abfa', component.options)
    }
    module.hot.accept("./JobCopySetting.vue?vue&type=template&id=cd20abfa&scoped=true&", function () {
      api.rerender('cd20abfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/NavbarMenu/components/SettingAndTools/JobCopySetting.vue"
export default component.exports